var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgContactUs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.0255 15.1501c3.7703 0 6.8253-2.5856 6.8253-5.775s-3.055-5.775-6.8253-5.775c-3.7702 0-6.8252 2.5856-6.8252 5.775 0 1.2666.4824 2.438 1.2994 3.3928-.1148.3084-.2854.5808-.466.8105-.1574.2034-.3182.3609-.4363.4692a4 4 0 0 1-.1411.1214.3.3 0 0 1-.0361.0263l-.0066.0065c-.1805.1345-.2592.3708-.187.5841s.2723.3642.4987.3642c.7154 0 1.4373-.1838 2.0378-.4102.3018-.1148.584-.2428.8301-.374 1.0074.4987 2.1789.7842 3.4323.7842m7.8753-5.775c0 3.6848-3.2518 6.4608-7.1041 6.7922.7973 2.4412 3.4421 4.2328 6.5791 4.2328 1.2535 0 2.4249-.2855 3.4356-.7842.2461.1312.525.2592.8269.374.6005.2264 1.3224.4102 2.0377.4102a.525.525 0 0 0 .4988-.3642.528.528 0 0 0-.1903-.5874l-.0066-.0065c-.0066-.0066-.0197-.0132-.0361-.0263a2.1 2.1 0 0 1-.1411-.1214c-.1181-.1083-.2789-.2658-.4364-.4692-.1805-.2297-.3511-.5053-.466-.8105.8171-.9515 1.2994-2.1229 1.2994-3.3928 0-3.045-2.7858-5.542-6.3199-5.7586.0132.1674.0197.338.0197.5086z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgContactUs);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/contact-us.36b6a96d53a75cc4270032a592355267.svg";